export function hasJobberAccess(user) {
  return Boolean(user?.isConnected || user?.jobberConnection?.accountId);
}
